export var Predicate;
(function (Predicate) {
    /**
     * Defined in:
     *   {@link file://./../../../../dxos/echo/model/document.proto}
     */
    let Operation;
    (function (Operation) {
        Operation[Operation["OR"] = 0] = "OR";
        Operation[Operation["AND"] = 1] = "AND";
        Operation[Operation["NOT"] = 2] = "NOT";
        Operation[Operation["IN"] = 10] = "IN";
        Operation[Operation["EQUALS"] = 11] = "EQUALS";
        Operation[Operation["GTE"] = 12] = "GTE";
        Operation[Operation["GT"] = 13] = "GT";
        Operation[Operation["LTE"] = 14] = "LTE";
        Operation[Operation["LT"] = 15] = "LT";
        Operation[Operation["PREFIX_MATCH"] = 20] = "PREFIX_MATCH";
        Operation[Operation["TEXT_MATCH"] = 21] = "TEXT_MATCH";
    })(Operation = Predicate.Operation || (Predicate.Operation = {}));
})(Predicate || (Predicate = {}));
export var ObjectMutation;
(function (ObjectMutation) {
    /**
     * Defined in:
     *   {@link file://./../../../../dxos/echo/model/document.proto}
     */
    let Operation;
    (function (Operation) {
        Operation[Operation["SET"] = 0] = "SET";
        Operation[Operation["DELETE"] = 1] = "DELETE";
        Operation[Operation["ARRAY_PUSH"] = 2] = "ARRAY_PUSH";
        Operation[Operation["SET_ADD"] = 4] = "SET_ADD";
        Operation[Operation["SET_DELETE"] = 5] = "SET_DELETE";
        Operation[Operation["YJS"] = 6] = "YJS";
    })(Operation = ObjectMutation.Operation || (ObjectMutation.Operation = {}));
})(ObjectMutation || (ObjectMutation = {}));
//# sourceMappingURL=document.js.map